import React from 'react'

const EmptyCart = () => (
    <div className="empty-cart">
        <img src="https://cdn.dribbble.com/users/357797/screenshots/3998541/empty_box.jpg" alt="empty cart" className="w-100"/>
    </div>
)

export default EmptyCart
